export default "__VITE_PUBLIC_ASSET__5b636898__"